import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const contactPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  'name': 'Contato - CSSBuySpreadsheet.asia',
  'description': 'Entre em contato com a equipe do CSSBuySpreadsheet.asia. Dúvidas sobre o CSSBuy Spreadsheet 2026, sugestões e colaborações.',
  'url': `${SITE_URL}/contato`,
  'inLanguage': 'pt',
  'isPartOf': {
    '@type': 'WebSite',
    'name': 'CSSBuy Spreadsheet',
    'url': SITE_URL,
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': [
    {
      '@type': 'ListItem',
      'position': 1,
      'name': 'CSSBuy Spreadsheet',
      'item': SITE_URL,
    },
    {
      '@type': 'ListItem',
      'position': 2,
      'name': 'Contato',
      'item': `${SITE_URL}/contato`,
    },
  ],
};

export default function Contato() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <JsonLd data={contactPageSchema} />
      <JsonLd data={breadcrumbSchema} />
      <Navbar />
      <main>
        <article className="w-full pt-24 pb-14 md:pt-28 md:pb-20">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <div className="mb-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
              >
                <i className="ri-arrow-left-line text-base"></i>
                Voltar ao Início
              </Link>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-8">
              Contato
            </h1>

            <div className="space-y-5 text-foreground-700 leading-relaxed text-sm md:text-base">
              <p>
                Tem alguma dúvida sobre o <strong>CSSBuy Spreadsheet</strong>? Quer sugerir novos produtos 
                ou categorias? Entre em contato conosco! Estamos sempre abertos a feedback e sugestões 
                da comunidade.
              </p>
              <p>
                <strong>Email:</strong> contato@cssbuyspreadsheet.asia
              </p>
              <p>
                Nossa equipe responde normalmente em até 48 horas úteis. Para questões urgentes relacionadas 
                ao <strong>CSSBuy Spreadsheet 2026</strong>, recomendamos visitar nossa 
                <Link to="/" className="text-primary-600 hover:text-primary-700 underline"> página inicial</Link> para 
                acessar as informações mais atualizadas.
              </p>
              <p>
                Se você deseja contribuir com o <strong>melhor CSSBuy Spreadsheet</strong> compartilhando 
                suas experiências, fotos QC ou recomendações de produtos, ficaremos muito felizes em 
                receber sua colaboração. A força do <strong>CSSBuy Spreadsheet</strong> está justamente 
                na comunidade ativa que o mantém atualizado e confiável.
              </p>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}